import { Box, Avatar, Typography,Button } from "@mui/material";
import LinkIcon from "../../assets/Link.png"

import {  IconButton} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";


 const Header = ({handleBack}) => {

  

  return (
    <Box display="flex" alignItems="center" p={"6px"} sx={{ background: "#fae14b" ,position: "fixed",width:"100%",zIndex: "999"}}>
      <IconButton onClick={handleBack}>
        <ArrowBackIcon />
      </IconButton>
      <Typography variant="h6" sx={{ fontWeight: 500, ml: 1 }}>
        Choose Any One 
      </Typography>
    </Box>
  );

  
};

export default Header;